<template>
  <div class="relative border border-dark-line rounded-xl overflow-hidden hover:border-accent">
    <div class="p-6">
      <img :src="product.photo.path" alt="" class="rounded-lg drop-shadow-[0_15px_15px_rgba(0,0,0,0.3)]">
      <h1 class="text-center mt-4">{{ product.name }}</h1>
      <div class="text-center mt-2 text-muted">
        <div class="mb-2" v-if="product.price">
          <span>{{ $helper.priceFormatter(product.price) }}</span>
          <span> | </span>
          <span>{{ product.inventory }} عدد</span>
        </div>
        <VBadge :type="product.active ? 'success' : 'danger' ">
          {{ product.active ? 'فعال' : 'غیرفعال' }}
        </VBadge>
      </div>
    </div>

    <button class="flex justify-center py-4 w-full text-accent bg-accent/20" @click="editModal = true">
      ویرایش
      <PenIcon class="fill-accent mr-2"/>
    </button>
  </div>

  <ModalService
      v-if="service"
      :show="editModal"
      :categories="categories"
      @click="editModal = !editModal"
      :service="product"
      @edited="edited"/>

  <ModalProduct
      v-else
      :show="editModal"
      @click="editModal = !editModal"
      :product="product"
      :categories="categories"
      @edited="edited"/>

</template>

<script>
import PenIcon from "@/components/Icons/PenIcon";
import VBadge from "@/components/General/VBadge";
import ModalProduct from "@/components/Modal/ModalProduct";
import ModalService from "@/components/Modal/ModalService";

export default {
  name: "ProductCard",
  components: {ModalService, ModalProduct, VBadge, PenIcon},
  emits: ['edited'],
  props: ['product', 'categories'],
  data() {
    return {
      editModal: false,
      service: this.$route.params.type === 'service'
    }
  },
  methods: {
    edited(product) {
      this.editModal = false
      this.$emit('edited', product)
    }
  }
}
</script>

<style scoped>

</style>